{
  "page": {
    "title": "Export orders"
  },
  "field": {
    "seller": "Seller",
    "date_range": "Date range"
  },
  "placeholder": {
    "select_range": "Select date range…"
  },
  "action": {
    "generate": "Generate export"
  },
  "column": {
    "filename": "File",
    "generated": "Generated",
    "download": "Download"
  }
}
